import { colors } from "../../constants/colors";

export const styles = {
  container: {
    p: 3,
    maxWidth: 600,
    margin: "0 auto",
    width: "100%",
  },
  paper: {
    p: 3,
    backgroundColor: colors.white.DEFAULT,
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  profileHeader: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    mb: 4,
    width: "100%",
  },
  avatar: {
    width: { xs: 60, sm: 80, md: 100 },
    height: { xs: 60, sm: 80, md: 100 },
    mb: 2,
    backgroundColor: colors.blue_green.DEFAULT,
  },
  name: {
    variant: "h4",
    color: colors.prussian_blue.DEFAULT,
    fontWeight: 600,
    mb: 0.5,
    textAlign: "center",
  },
  email: {
    color: colors.prussian_blue[300],
    textAlign: "center",
  },
  sectionTitle: {
    variant: "h6",
    color: colors.prussian_blue.DEFAULT,
    fontWeight: 600,
    mb: 3,
    textAlign: "center",
    width: "100%",
  },
  formField: {
    width: { xs: "90%", sm: "80%", md: "70%" },
    mb: 2,
    "& .MuiInputBase-root": {
      backgroundColor: colors.white.DEFAULT,
      padding: { xs: "6px 10px", sm: "8px 12px", md: "10px 14px" },
      height: { xs: "40px", sm: "48px", md: "56px" },
      "&:hover, &.Mui-focused": {
        backgroundColor: colors.white.DEFAULT,
      },
    },
    "& .MuiFormHelperText-root": {
      color: colors.blue_green[300],
    },
    "& .MuiTextField-root": {
      width: "100%",
    },
    "& .MuiOutlinedInput-root": {
      margin: 0,
      padding: 0,
    },
  },
  actionButton: {
    display: "flex",
    justifyContent: "center",
    mt: 4,
    width: { xs: "90%", sm: "80%", md: "70%" },
  },
  editButton: {
    color: colors.blue_green.DEFAULT,
    borderColor: colors.blue_green.DEFAULT,
    width: "100%",
    "&:hover": {
      borderColor: colors.blue_green[400],
      backgroundColor: colors.blue_green[900],
    },
  },
  saveButton: {
    backgroundColor: colors.blue_green.DEFAULT,
    width: "100%",
    "&:hover": {
      backgroundColor: colors.blue_green[400],
    },
  },
  closeButton: {
    position: "absolute",
    right: 8,
    top: 8,
  },
};
